<button
  [type]="type"
  [disabled]="disabled || loading"
  [ngClass]="[
    'btn',
    colorClasses,
    sizeClasses,
    roundedClasses,
    widthClass,
    (disabled || loading) ? 'opacity-50 cursor-not-allowed' : '',
    'flex items-center justify-center'
  ]"
  (click)="onClick($event)">
  <span *ngIf="loading" class="inline-block mr-2">
    <app-loading [size]="loadingSize" [color]="'white'"></app-loading>
  </span>
  <ng-content></ng-content>
</button>
